import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/Tabs/Tabs.tsx");
